export enum eTypePickingRouteMovement {
  PickingRoute = 1,
  Validation = 2
}
